import { useEffect, useRef } from "react";
import {
    fetchedDispatchDetailsByWarehouse,
    fetchedUsersByGang,
} from "../../../apis/apis.dispatches/apisDispatch";
import { fetchedGangs } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";

const inputCls  = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelCls  = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

export function DistributionFilter({
    setOrders,
    gangs,
    setGangs,
    users,
    setUsers,
    operationStatus,
    setFilename,
    questionState,
    setQuestionState,
    getCurrentDate,
    ordersCount,
    registerSearchFn,
}) {
    // Expose the search function to the parent so DistributionList can call it
    const questionStateRef = useRef(questionState);
    questionStateRef.current = questionState;

    const getGangs = async () => {
        try { setGangs(await fetchedGangs()); }
        catch (error) { throw error; }
    };

    const getUsersByGang = async (id) => {
        try { setUsers(await fetchedUsersByGang({ gangID: id })); }
        catch (error) { throw error; }
    };

    const sendFilterDispatches = async (data) => {
        try {
            const response = await fetchedDispatchDetailsByWarehouse(data);
            setOrders(response);
            return response;
        } catch (error) { throw error; }
    };

    const searchSuggestions = () => {
        sendFilterDispatches(questionStateRef.current).then((res) => {
            const n = res.length;
            toast.info(n > 1 ? `Se encontraron ${n} resultados.` : `Se encontró ${n} resultado(s).`);
        });
    };

    // Register the search function so the parent (and DistributionList) can call it
    useEffect(() => {
        registerSearchFn?.(() => searchSuggestions);
    }, []);

    function handleChange(e) {
        const updated = { ...questionState, [e.target.name]: e.target.value };
        setQuestionState(updated);
        if (e.target.name === "gangID") {
            const select = document.getElementById("gangID");
            const text   = select.options[select.selectedIndex].text;
            setFilename(`ReporteVentas_${text.replace(/\s/g, "")}_${getCurrentDate("-")}`);
            getUsersByGang(e.target.value);
        }
    }

    const handleReset = () =>
        setQuestionState({
            startDate:       getCurrentDate("-"),
            endDate:         getCurrentDate("-"),
            subsidiaryID:    questionState.subsidiaryID,
            warehouseID:     0,
            gangID:          0,
            userID:          0,
            operationStatus: "02",
            documentType:    "02",
            mode:            "01",
            httpStatusCode:  200,
        });

    useEffect(() => { getGangs(); }, []);

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">

            {/* Panel header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                    <h2 className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                        <i className="fas fa-filter text-blue-500"></i>
                        Filtros de búsqueda
                    </h2>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                        Configure los parámetros para filtrar las distribuciones
                    </p>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 dark:bg-gray-700 px-3 py-1 text-xs font-medium text-gray-600 dark:text-gray-300">
                    <span className="h-1.5 w-1.5 rounded-full bg-blue-500"></span>
                    {ordersCount} registros
                </span>
            </div>

            {/* Filters grid */}
            <div className="px-5 py-4 space-y-4">

                {/* Row 1 */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">

                    {/* Ruta */}
                    <div>
                        <label htmlFor="gangID" className={labelCls}>
                            <i className="fas fa-route mr-1"></i>Ruta
                        </label>
                        <select id="gangID" name="gangID" value={questionState.gangID} onChange={handleChange} className={inputCls}>
                            <option value={0}>Seleccionar ruta...</option>
                            {gangs.map((item, i) => (
                                <option key={i} value={item.gangID}>{item.gangName}</option>
                            ))}
                        </select>
                    </div>

                    {/* Usuario */}
                    <div>
                        <label className={labelCls}><i className="fas fa-user mr-1"></i>Usuario</label>
                        <select name="userID" value={questionState.userID} onChange={handleChange} className={inputCls}>
                            <option value={0}>Seleccionar usuario...</option>
                            {users.map((item, i) => (
                                <option key={i} value={item.id}>{item.first_name} {item.last_name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Tipo Doc */}
                    <div>
                        <label className={labelCls}><i className="fas fa-file-alt mr-1"></i>Tipo Doc.</label>
                        <select name="documentType" value={questionState.documentType} onChange={handleChange} className={inputCls}>
                            <option value="02">BOLETA</option>
                            <option value="03">FACTURA</option>
                            <option value="01">TICKET</option>
                        </select>
                    </div>

                    {/* Emitido */}
                    <div>
                        <label className={labelCls}><i className="fas fa-check-circle mr-1"></i>Emitido</label>
                        <select name="httpStatusCode" value={questionState.httpStatusCode} onChange={handleChange} className={inputCls}>
                            <option value={200}>SÍ</option>
                            <option value={0}>NO</option>
                            <option value={400}>CON ERROR</option>
                        </select>
                    </div>

                    {/* Visualización */}
                    <div>
                        <label className={labelCls}><i className="fas fa-eye mr-1"></i>Visualización</label>
                        <select name="mode" value={questionState.mode} onChange={handleChange} className={inputCls}>
                            <option value="01">Detallado</option>
                            <option value="02">Resumido</option>
                        </select>
                    </div>
                </div>

                {/* Row 2 */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 items-end">

                    {/* Tipo de Pedido */}
                    <div className="lg:col-span-3">
                        <label className={labelCls}><i className="fas fa-shopping-cart mr-1"></i>Tipo de Pedido</label>
                        <select name="operationStatus" value={questionState.operationStatus} onChange={handleChange} className={inputCls}>
                            {operationStatus.map((item, i) => (
                                <option key={i} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Desde */}
                    <div className="lg:col-span-2">
                        <label className={labelCls}><i className="fas fa-calendar-alt mr-1"></i>Desde</label>
                        <input type="date" name="startDate" value={questionState.startDate} onChange={handleChange} className={inputCls} />
                    </div>

                    {/* Hasta */}
                    <div className="lg:col-span-2">
                        <label className={labelCls}><i className="fas fa-calendar-alt mr-1"></i>Hasta</label>
                        <input type="date" name="endDate" value={questionState.endDate} onChange={handleChange} className={inputCls} />
                    </div>

                    {/* Buscar */}
                    <div className="lg:col-span-3">
                        <button
                            id="btn-filter"
                            onClick={searchSuggestions}
                            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                        >
                            <i className="fas fa-search"></i>
                            Buscar distribuciones
                        </button>
                    </div>

                    {/* Limpiar */}
                    <div className="lg:col-span-2">
                        <button
                            onClick={handleReset}
                            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm font-medium px-4 py-2 transition-colors"
                        >
                            <i className="fas fa-undo"></i>
                            Limpiar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
